import intersectEffects from "./intersectEffects";
const intersect = intersectEffects()

const banner = {
    showHomeLogo() {
        let that = this;
        setTimeout(() => {
            that.$el.classList.remove('out');
        }, 1000);
    }
}

export default() => {
    return {
        ...banner,
        ...intersect
    }
}